export default function() {
    this.loadTemplate()
    this.loadWhatsappTemplates()
}
